import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerOverlay,
  Flex,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { MinimumRequirementDto } from "../../../../../autogen/bff-api";
import {
  MinimumRequirementFields,
  type MinimumRequirementFormValues,
} from "../../../../../common/library/fields/MinimumRequirementFields";
import { RequirementDialogHeader } from "../../../../../common/components/RequirementDialogHeader";

// t('Add minimum requirement') t('Edit minimum requirement') t('Cancel') t('Save')

export type { MinimumRequirementFormValues };

interface Props {
  isOpen: boolean;
  isSaving: boolean;
  mode: "add" | "edit";
  defaultValues?: MinimumRequirementFormValues;
  onSubmit: (values: Omit<MinimumRequirementDto, "id">) => Promise<void>;
  onClose: () => void;
}

const FORM_ID = "minimum-requirement-drawer-form";

export const MinimumRequirementDrawer = ({
  isOpen,
  isSaving,
  mode,
  defaultValues,
  onSubmit,
  onClose,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
      <DrawerOverlay />
      <DrawerContent>
        <RequirementDialogHeader title={t(mode === "edit" ? "Edit minimum requirement" : "Add minimum requirement")} />

        <DrawerBody>
          <MinimumRequirementFields
            formId={FORM_ID}
            defaultValues={defaultValues}
            onSubmit={onSubmit}
          />
        </DrawerBody>

        <DrawerFooter borderTopWidth="1px" borderColor="smBorder">
          <Flex gap="3">
            <Button variant="outline" onClick={onClose}>
              {t("Cancel")}
            </Button>
            <Button type="submit" form={FORM_ID} colorScheme="teal" isLoading={isSaving}>
              {t("Save")}
            </Button>
          </Flex>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
